import { create } from 'zustand';
import { DateRange } from 'react-day-picker';
import { ColumnState } from 'ag-grid-community';

import { defaultMST1110_R01Dto, MST1110_R01Dto } from './Dto_MST1110_R01';
import { formatDateMonth, formatDateYear4 } from 'src/utils/string/stringUtil';
import { showWarning } from 'src/utils/toast/toastUtil';

export interface MST1110_R01Filter {
	logicCenter: string;
	warehouseCd: string;
}

export interface Store_MST1110_R01 {
	MST1110_R01Filter: MST1110_R01Filter;
	MST1110_R01PastFilter: MST1110_R01Filter;
	setMST1110_R01Filter: (filter: Partial<MST1110_R01Filter>) => void;
	setMST1110_R01PastFilter: (filter: Partial<MST1110_R01Filter>) => void;

	MST1110_R01List: MST1110_R01Dto[];
	setMST1110_R01List: (MST1110_R01List: MST1110_R01Dto[]) => void;
	insertMST1110_R01List: (data: MST1110_R01Dto[], index?: number) => void;
	removeMST1110_R01List: (index: number) => void;
	updateMST1110_R01List: (index: number, MST1110_R01List: MST1110_R01Dto) => void;

	deletedMST1110_R01List: string[];
	addDeletedMST1110_R01List: (idList: string[]) => void;
	removeDeletedMST1110_R01List: (idList?: string[]) => void;

	selectedMST1110_R01List: string[];
	setSelectedMST1110_R01List: (idList: string[]) => void;
	addSelectedMST1110_R01List: (idList: string[]) => void;
	removeSelectedMST1110_R01List: (idList?: string[]) => void;
	initSelectedMST1110_R01List: () => void;
	allSelectedMST1110_R01List: () => void;

	originalMST1110_R01List: MST1110_R01Dto[];
	setOriginalMST1110_R01List: (list: MST1110_R01Dto[]) => void;

	columnState: ColumnState[] | null;		setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	initData: () => void;

}

export interface Store_MST1110_R01_GridCalendarState {

	// ====== MST1110_R01 GridCalendar 상태 ======
	MST1110_R01GridCalendarState: {
		pickerVisible: boolean;
		pickerPosition: { top: number; left: number };
		targetRowIndex: number | null;
		targetField: string | null;
		targetDate: Date | undefined;
	};
	setMST1110_R01GridCalendarState: (state: Partial<Store_MST1110_R01_GridCalendarState['MST1110_R01GridCalendarState']>) => void;
	initMST1110_R01GridCalendarState: () => void;

}

export const defaultMST1110_R01Filter: MST1110_R01Filter = {
	logicCenter: '',
	warehouseCd: ''
};

export const useMST1110_R01Store = create<Store_MST1110_R01>((set) => ({
	MST1110_R01Filter: defaultMST1110_R01Filter,
	MST1110_R01PastFilter: defaultMST1110_R01Filter,
	setMST1110_R01Filter: (update) => set((state) => ({
		MST1110_R01Filter: {
			...state.MST1110_R01Filter,
			...update
		}
	})),
	setMST1110_R01PastFilter: (update) => set((state) => ({
		MST1110_R01PastFilter: {
			...state.MST1110_R01PastFilter,
			...update
		}
	})),

	MST1110_R01List: [],
	setMST1110_R01List: (MST1110_R01List: MST1110_R01Dto[]) => set((state) => {
		let newList: MST1110_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		MST1110_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultMST1110_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			MST1110_R01List: newList
		}
	}),
	insertMST1110_R01List: (data: MST1110_R01Dto[], index?: number) => set((state) => {
		let newMST1110_R01List = [...state.MST1110_R01List];

		let targetRowData = newMST1110_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newMST1110_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newMST1110_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newMST1110_R01List = newMST1110_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newMST1110_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultMST1110_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newMST1110_R01List.splice(index, 0, ...newData);
		} else {
			newMST1110_R01List.push(...newData);
		}

		return {
			...state,
			MST1110_R01List: newMST1110_R01List
		}
	}),
	removeMST1110_R01List: (index: number) => set((state) => {
		const newMST1110_R01List = [...state.MST1110_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			MST1110_R01List: newMST1110_R01List
		}
	}),
	updateMST1110_R01List: (valueIndex: number, data: MST1110_R01Dto) => set((state) => {
		const _MST1110_R01List = state.MST1110_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			MST1110_R01List: _MST1110_R01List
		}
	}),


	deletedMST1110_R01List: [],
	addDeletedMST1110_R01List: (idList: string[]) => set((state) => {
		const _deletedMST1110_R01List = [...state.deletedMST1110_R01List];

		for(const valueIndex of idList) {
			const isInserted = state.MST1110_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.MST1110_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedMST1110_R01List.push(valueIndex);
			}
		}
		return {
			...state,
			deletedMST1110_R01List: _deletedMST1110_R01List
		}
	}),
	removeDeletedMST1110_R01List: (idList?: string[]) => set((state) => ({
		...state,
		deletedMST1110_R01List: [...state.deletedMST1110_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedMST1110_R01List: [],
	setSelectedMST1110_R01List: (idList: string[]) => set({ selectedMST1110_R01List: idList }),
	addSelectedMST1110_R01List: (idList: string[]) => set((state) => {
		const _selectedMST1110_R01List = [...state.selectedMST1110_R01List];
		if(idList.length > 0) {
			_selectedMST1110_R01List.push(...idList);
		}
		return {
			...state,
			selectedMST1110_R01List: _selectedMST1110_R01List
		}
	}),
	removeSelectedMST1110_R01List: (idList?: string[]) => set((state) => ({
		...state,
		selectedMST1110_R01List: [...state.selectedMST1110_R01List].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedMST1110_R01List: () => set({ selectedMST1110_R01List: [] }),
	allSelectedMST1110_R01List: () => set((state) => {
		const _selectedMST1110_R01List = [...state.MST1110_R01List.map(item => item.valueIndex.toString())];
		return {
			...state,
			selectedMST1110_R01List: _selectedMST1110_R01List
		}
	}),

	originalMST1110_R01List: [],
	setOriginalMST1110_R01List: (MST1110_R01List: MST1110_R01Dto[]) => set((state) => {
		let newList: MST1110_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		MST1110_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultMST1110_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalMST1110_R01List: newList
		}
	}),

	columnState: null,			setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		MST1110_R01Filter: defaultMST1110_R01Filter,
		MST1110_R01PastFilter: defaultMST1110_R01Filter,
		MST1110_R01List: [],
		selectedMST1110_R01List: [],
		deletedMST1110_R01List: [],
		allCount: 0,
		scrollTop: null,
	})),

}));


export const useMST1110_R01Store_GridCalendar = create<Store_MST1110_R01_GridCalendarState>((set) => ({

	// ====== GridCalendar 상태 ======
	MST1110_R01GridCalendarState: {
		pickerVisible: false,
		pickerPosition: { top: 0, left: 0 },
		targetRowIndex: null,
		targetField: null,
		targetDate: undefined
	},
	setMST1110_R01GridCalendarState: (newState: Partial<Store_MST1110_R01_GridCalendarState['MST1110_R01GridCalendarState']>) => set((state) => ({
		...state,
		MST1110_R01GridCalendarState: { ...state.MST1110_R01GridCalendarState, ...newState }
	})),
	initMST1110_R01GridCalendarState: () => set((state) => ({
		...state,
		MST1110_R01GridCalendarState: {
			pickerVisible: false,
			pickerPosition: { top: 0, left: 0 },
			targetRowIndex: null,
			targetField: null,
			targetDate: undefined
		}
	})),


})); 